import { render, staticRenderFns } from "./ChartEstudiantesxCarrera.vue?vue&type=template&id=256ad454&"
import script from "./ChartEstudiantesxCarrera.vue?vue&type=script&lang=js&"
export * from "./ChartEstudiantesxCarrera.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports